var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

import { extendObservable } from 'mobx';
import { findNode } from '../util/tree';
import findPathFromRoot from './util/findPathFromRoot';

var RouterStateTree = function () {
  function RouterStateTree(root) {
    _classCallCheck(this, RouterStateTree);

    extendObservable(this, {
      root: root
    });
  }

  _createClass(RouterStateTree, [{
    key: 'find',
    value: function find(predicate) {
      return findNode(predicate, this.root);
    }
  }, {
    key: 'pathFromRoot',
    value: function pathFromRoot(url) {
      return findPathFromRoot(this.root, url);
    }
  }, {
    key: 'pathFrom',
    value: function pathFrom(node, url, params, mountUrl) {
      return findPathFromRoot(node, url, params, mountUrl);
    }
  }]);

  return RouterStateTree;
}();

export default RouterStateTree;